// DirectorySuccess.jsx
import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const DirectorySuccess = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const companyId = params.get("companyId");

  useEffect(() => {
    // Optional: trigger some state update or local storage flag
    // Then redirect back to the page/modal
    if (companyId) {
      // Set flag in localStorage to re-open modal
      localStorage.setItem("google_connected_company", companyId);

      // ✅ Redirect back to the page where the modal is used
      navigate("/dashboard"); // or wherever your modal lives
    }
  }, [companyId, navigate]);

  return <p>Completing connection...</p>;
};

export default DirectorySuccess;
